import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useStateRef from "react-usestateref";
import Helper from "../Helper";
import { APPLICATION_JSON } from "../../middleware/types";
import { organizationDetailsAction } from "../../middleware/organizationDetailsAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const ImpersonateHeader = () => {
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [userTypeCheck, setUserTypeCheck, userTypeCheckRef] = useStateRef('');
    const  [ userId, setUserId, userIdRef]= useStateRef('');
    const history = useHistory();
   
    useEffect(() => {
        setUserTypeCheck(profileDetails.userTypeCheck);
        setUserId(profileDetails.userId);
    }, [profileDetails])

    async function handleEndUserSession(event){
        event.preventDefault();
        var actionUrl = "api/rest/cb/profile/end-impersonate-user-session";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        // var inputMap = {userId: userIdRef.current, JDENumber : userTypeCheckRef.current && userTypeCheckRef.current.accountNumber && userTypeCheckRef.current.accountNumber}
        var inputMap ={testInput : 'true'}
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        
        if (res.response != null) {
           if(res.response.status ==='success'){
            var response = res.response && res.response.response;
            response =JSON.parse(response); 
           loginWithoutPassword(response.user);
           }
           
        } else {
        }
    
    }
    async function loginWithoutPassword(user){
        var actionUrl = "api/rest/cb/profile/login-without-password";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = {user: user}
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        
            if (res.response != null) {
                var response =res.response.response
                response = JSON.parse(response);
                if(response.error==='false'){
                    history.push('/csr/csr-search');
                }
             } else {
             }
    }
    async function handleLogMeOut(event){
        event.preventDefault();
        var actionUrl = "api/rest/cb/profile/impersonate-log-me-out";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = {JDENumber : userTypeCheckRef.current && userTypeCheckRef.current.accountNumber && userTypeCheckRef.current.accountNumber}
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
            var response =res.response.response
            response = JSON.parse(response);
            if(response.error==='false'){
                history.push('/');
            }
        } else {
        }
    
    }

return(
    <>
    <div id="csr_head">
        <div className="c-container bg-light-grey csr-header">
            <div className="row align-items-start mt-3">
                <div className="col-12 col-md-7 mb-2 mb-md-0">
                    <div className="row">
                      <div className="col-12 col-md-10 col-two">
                        <dl className="d-flex flex-wrap ">
                            <dt>Logged in as:</dt>
                            <dd>{userTypeCheckRef.current.loggedInAs && userTypeCheckRef.current.loggedInAs}</dd>
                            <dt>Email:</dt>
                            <dd>{userTypeCheckRef.current.email && userTypeCheckRef.current.email}</dd>
                            <dt>JDE Account #:</dt>
                            <dd>{userTypeCheckRef.current.accountNumber && userTypeCheckRef.current.accountNumber}</dd>
                            <dt>Price List:</dt>
                            <dd>{userTypeCheckRef.current.priceList && userTypeCheckRef.current.priceList}</dd>
                            <dt>Cust Type:</dt>
                            <dd>{userTypeCheckRef.current.custType && userTypeCheckRef.current.custType}</dd>
                            <dt>Role:</dt>
                            <dd>{userTypeCheckRef.current.role && userTypeCheckRef.current.role}</dd>
                            <dt>Spend Limit</dt>
                            <dd>{userTypeCheckRef.current.spendLimit && userTypeCheckRef.current.spendLimit}</dd>
                        </dl>
                      </div>
                    </div>
                </div>
                <div className="col-12 col-md-5">
                    <ul className="list-unstyled d-flex justify-content-center justify-content-md-end mb-0">
                        <li><Link onClick={handleEndUserSession} className="btn btn-danger me-1" >End User Session or Change User</Link></li>
                        <li><Link onClick={handleLogMeOut} className="btn btn-danger">Log Me Out</Link></li>
                     </ul>
                </div>
            </div>
        </div>
    </div>
    </>
)
}